<template lang="pug">
  .apex
    apexchart(type="bar" :options="chartOptions" :series="series")
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'c_chart_bar',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    series: {
      type: Array,
      required: true,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    yAxisTitle: {
      type: String,
      default: ''
    },
    xAxisTitle: {
      type: String,
      default: ''
    },
    tooltipFormatter: {
      type: Function,
      default: (val) => `${val}`
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    isOneSeries: {
      type: Boolean,
      default: true
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Mi titulo'
    },
    showXlabels: {
      type: Boolean,
      default: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          type: 'bar',
          height: '1000px'
        },
        plotOptions: {
          bar: {
            horizontal: this.isHorizontal,
            columnWidth: '55%',
            endingShape: 'rounded',
            distributed: this.isOneSeries
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: this.categories,
          labels: {
            show : this.showXlabels
          },
          title: {
            text: this.xAxisTitle
          }
        },
        yaxis: {
          title: {
            text: this.yAxisTitle
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: this.tooltipFormatter
          }
        },
        theme: {
          monochrome: {
            enabled : false
          },
          palette: 'palette1'
        },
        title: {
          text: this.title
        },
        subtitle:{
          text: this.subtitle
        },
        legend: {
          show: this.showLegend
        }
      };
    }
  }
};
</script>

<style lang="stylus" scoped>
  .apex
    width 100%
    height 100%
    margin 0 auto
    padding 20px
    box-sizing border-box
</style>




// WEBPACK FOOTER //
// c_chart_bar.vue?e1041d5a